
export function UserCwid() {
    let user = localStorage.getItem('cwid-user');
    return user?.toString().toLowerCase();
}